/* Blank Slaps — Email Sign-up (Variant C · Falling Slaps)
   Owned by the email-sign-up build. Do not fold into empire.js.liquid.

   Two jobs only:
   1. Remember the address the visitor typed so the success state can echo it
      back. Shopify's {% form 'customer' %} redirects and does not hand the
      submitted value back to Liquid, so we stash it in sessionStorage.
   2. Allow the success state to be previewed locally with ?bs_signup_success=1
      (also honours Shopify's own ?customer_posted=true).
   No animation is driven from here — the drift is pure CSS so
   prefers-reduced-motion is respected without JS.
*/
(function () {
  'use strict';

  var STORE_KEY = 'bs-es-email';

  function read() {
    try { return window.sessionStorage.getItem(STORE_KEY) || ''; }
    catch (e) { return ''; }
  }

  function write(value) {
    try { window.sessionStorage.setItem(STORE_KEY, value); }
    catch (e) { /* private mode — the success state just drops the echo row */ }
  }

  function forced() {
    var q = window.location.search;
    return q.indexOf('bs_signup_success=1') > -1 || q.indexOf('customer_posted=true') > -1;
  }

  function init(root) {
    if (root.hasAttribute('data-bs-es-ready')) return;
    root.setAttribute('data-bs-es-ready', '');

    var input = root.querySelector('[data-bs-es-email]');
    var form = input ? input.form : null;

    if (form) {
      form.addEventListener('submit', function () {
        if (input.value) write(input.value.trim());
      });
    }

    if (forced()) root.setAttribute('data-bs-state', 'done');

    if (root.getAttribute('data-bs-state') !== 'done') return;

    var confirm = root.querySelector('[data-bs-es-confirm]');
    var slot = root.querySelector('[data-bs-es-confirm-email]');
    var email = read();

    // No stored address means we have nothing truthful to echo — leave the
    // confirmation block hidden rather than printing a placeholder. The band
    // keeps its footprint either way.
    if (confirm && slot && email) {
      slot.textContent = email;
      confirm.hidden = false;
    }
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-bs-email-signup]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', boot);
})();
